
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.952 11.351a1 1 0 011.42-.004l3.9 3.91a2 2 0 01-.011 2.835l-.485.479a2 2 0 01-2.812 0l-3.914-3.869a1 1 0 01-.009-1.413l1.91-1.938zm2.721-3.494a1 1 0 01-1.41.003L13 7.6l-4.79 4.8v1.97l-4.207 4.207a2 2 0 01-2.837-.008l-.469-.475a2 2 0 01.009-2.82L4.89 11.09h1.97l.78-.78L3.8 6.46H2.5L.39 4.327a1 1 0 01.003-1.41l1.21-1.21a1 1 0 011.414 0L5.11 3.8v1.31L9 8.95l2.66-2.66-.96-1.01L12 3.97H9.61a.65.65 0 01-.461-1.11L11.534.468a.66.66 0 011.126.465V3.32L13.97 2l3.28 3.28a2.84 2.84 0 01.57 3.153c-.227.507-.888.503-1.277.106L15.28 7.25l-.607.607z","fill":"#A9AFB5"}})])
          )
        }
      }
    